// ADDED
import { useState, useCallback, useEffect } from "react";
import { medicalClearanceAccessService } from "../services/medicalClearanceAccessService";
import { useGeneralMessage } from "../../common/APICommon";

export const useMedicalClearanceAccess = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [filterData, setFilterData] = useState([]);
  
  const { showGeneralMessage, showMessage, message, isSuccess } = useGeneralMessage();

  const fetchAccessTemplates = useCallback(async () => {
    setLoading(true);
    try {
      const res = await medicalClearanceAccessService.getAll();
      setData(res.data || []);
      setFilterData(res.data || []);
    } catch (err) {
      showGeneralMessage("Failed to load access templates", false);
    } finally {
      setLoading(false);
    }
  }, [showGeneralMessage]);

  useEffect(() => {
    fetchAccessTemplates();
  }, [fetchAccessTemplates]);

  const updateAccess = async (id, roleType) => {
    setLoading(true);
    try {
      const payload = {
        isMedicalClearanceManager: roleType === "manager",
        isMedicalClearanceProcessor: roleType === "processor"
      };

      await medicalClearanceAccessService.update(id, payload);
      showGeneralMessage("Access updated successfully", true);
      await fetchAccessTemplates();
      return true;
    } catch (err) {
      const errorMsg = err.response?.data?.message || "Failed to update access";
      showGeneralMessage(errorMsg, false);
      return false;
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (value) => {
    if (!value) {
      setData(filterData);
      return;
    }
    const lower = value.toLowerCase();
    setData(filterData.filter(f => f.description?.toLowerCase().includes(lower)));
  };

  return {
    loading,
    data,
    showMessage,
    message,
    isSuccess,
    handleSearch,
    updateAccess,
    refresh: fetchAccessTemplates
  };
};